import { memo } from 'react';
import { MButton } from '@Components/Base';
import { Form } from 'antd';
import { useAppSelector } from '@Hooks/index';
import { currentMaterialManagest } from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';

import styles from './footer-buttons.module.css';

interface MRButtonsProps {
  disabledSaveForm: boolean;
  disabledNextStep: boolean;
  onSaveAsDraft: () => void;
  onNext: () => void;
  onConfirm: () => void;
}

const MRButtons: React.FC<MRButtonsProps> = ({
  disabledSaveForm,
  disabledNextStep,
  onSaveAsDraft,
  onNext,
  onConfirm,
}) => {
  const { showConfirmButton } = useAppSelector(currentMaterialManagest);
  return (
    <>
      <Form.Item>
        <MButton
          type="secondary"
          onClick={onSaveAsDraft}
          disabled={disabledSaveForm}
          className={styles.saveAsDraftButton}
        >
          Save As Draft
        </MButton>
      </Form.Item>
      {showConfirmButton ? (
        <Form.Item>
          <MButton
            className={styles.confirmButton}
            type="primary"
            onClick={onConfirm}
          >
            Review & Confirm
          </MButton>
        </Form.Item>
      ) : (
        <Form.Item>
          <MButton
            className={styles.nextButton}
            type="primary"
            onClick={onNext}
            disabled={disabledNextStep}
          >
            Next
          </MButton>
        </Form.Item>
      )}
    </>
  );
};

export default memo(MRButtons);
